import React, { FC } from "react";

type CancellationMessageProps = {
  message: string;
};

export const CancellationMessage: FC<CancellationMessageProps> = ({
  message,
}) => {
  return (
    <p
      className="mt-0"
      dangerouslySetInnerHTML={{
        __html: message,
      }}
    />
  );
};
